import styled from 'styled-components';
import { Card } from 'components/Page';
import { CardProps } from 'components/Page/Card/Card';

export const StyledCard = styled(Card)<CardProps>`
  height: 100%;
  box-sizing: border-box;
`;
